import React from "react";
import { CrownOutlined, HomeOutlined, ShoppingCartOutlined, UserOutlined } from "@ant-design/icons";
import PartnersType from "../Subscription/PartnersType";

// Locals

const SepteoProspectType = {
    vendor: '2' as ProspectTypeValues,
    buyer: '17' as ProspectTypeValues,
    // tenant: '1' as ProspectTypeValues,
    owner: '24' as ProspectTypeValues,
    // investisor: '25' as ProspectTypeValues,
    prospect: '29' as ProspectTypeValues,
} as const;

const septeoProspectTypeAsString = (type: ProspectType | string): string => {
    switch (type) {
        case SepteoProspectType.buyer:
            return 'Acquéreur';
        case SepteoProspectType.vendor:
            return 'Vendeur';
        // case SepteoProspectType.tenant:
        //     return 'Locataire';
        case SepteoProspectType.owner:
            return 'Propriétaire';
        // case SepteoProspectType.investisor:
        //     return 'Investisseur';
        case SepteoProspectType.prospect:
            return 'Prospect';
        default:
            return type.toString();

    }
};

const renderSepteoProspectTypeOption = (type: ProspectType | string): React.ReactNode => {
    switch (type) {
        case SepteoProspectType.buyer:
            return <>
                <ShoppingCartOutlined style={{ marginRight: 6 }} />
                {septeoProspectTypeAsString(type)}
            </>;
        case SepteoProspectType.vendor:
            return <>
                <HomeOutlined style={{ marginRight: 6 }} />
                {septeoProspectTypeAsString(type)}
            </>;
        case SepteoProspectType.owner:
            return <>
                <CrownOutlined style={{ marginRight: 6 }} />
                {septeoProspectTypeAsString(type)}
            </>;
        case SepteoProspectType.prospect:
            return <>
                <UserOutlined style={{ marginRight: 6 }} />
                {septeoProspectTypeAsString(type)}
            </>;
        default:
            return septeoProspectTypeAsString(type);

    }
}

const OrishaProspectType = {
    buyer: '1' as ProspectTypeValues,
    seller: '2' as ProspectTypeValues,
    // tenant: '15' as ProspectTypeValues,
    landlord: '19' as ProspectTypeValues,
} as const;

const orishaProspectTypeAsString = (type: ProspectType | string): string => {
    switch (type) {
        case OrishaProspectType.buyer:
            return 'Demandeur';
        case OrishaProspectType.seller:
            return 'Vendeur';
        // case OrishaProspectType.tenant:
        //     return 'Locataire';
        case OrishaProspectType.landlord:
            return 'Propriétaire';
        default:
            return type.toString();

    }
};

const renderOrishaProspectTypeOption = (type: ProspectType | string): React.ReactNode => {
    switch (type) {
        case OrishaProspectType.buyer:
            return <>
                <ShoppingCartOutlined style={{ marginRight: 6 }} />
                {orishaProspectTypeAsString(type)}
            </>;
        case OrishaProspectType.seller:
            return <>
                <HomeOutlined style={{ marginRight: 6 }} />
                {orishaProspectTypeAsString(type)}
            </>;
        case OrishaProspectType.landlord:
            return <>
                <CrownOutlined style={{ marginRight: 6 }} />
                {orishaProspectTypeAsString(type)}
            </>;
        default:
            return orishaProspectTypeAsString(type);

    }
}

// Exports

export type ProspectTypeValues = string;

export type ProspectType = typeof ProspectType[keyof typeof ProspectType];

export const prospectTypeAsString = (type: ProspectType | string, partnerType: PartnersType): string => {
    switch (partnerType) {
        case PartnersType.septeo:
            return septeoProspectTypeAsString(type);
        case PartnersType.orisha:
            return orishaProspectTypeAsString(type);
        default:
            return septeoProspectTypeAsString(type);
    }
};

export const ProspectType = {
    [PartnersType.septeo]: SepteoProspectType,
    [PartnersType.orisha]: OrishaProspectType,
}

export const renderProspectTypeOption = (type: ProspectType | string, partnerType: PartnersType): React.ReactNode => {
    switch (partnerType) {
        case PartnersType.septeo:
            return renderSepteoProspectTypeOption(type);
        case PartnersType.orisha:
            return renderOrishaProspectTypeOption(type);
        default:
            return renderSepteoProspectTypeOption(type);
    }
};